export const CURRENT_USER_GET_DETAILS = 'CURRENT_USER_GET_DETAILS';
export const CURRENT_USER_GET_FAILURE = 'CURRENT_USER_GET_FAILURE';
export const CURRENT_USER_SET = 'CURRENT_USER_SET';
export const CURRENT_USER_SET_GUEST = 'CURRENT_USER_SET_GUEST';
export const CURRENT_USER_INCREMENT_TICK = 'CURRENT_USER_INCREMENT_TICK';
